export type Colors = typeof colors;

export const colors = {
  primary: {
    base: `hsl(354, 81%, 42%)`,
    baseBg: `hsla(354, 81%, 42%,.1)`,
    darker: `hsl(354, 81%, 32%)`,
    darkest: `hsl(354, 81%, 22%)`,
    lighter: `hsl(354, 81%, 62%)`,
    lightest: `hsl(354, 81%, 85%)`,
  },
  secondary: `hsl(205, 37%, 31%)`,
  background: `hsl(0, 0%, 90%)`,
  prismicBackground: `hsl(34, 23%, 94%)`,
  heading: `hsl(205, 37%, 31%)`,
  headingDarker: `hsl(205, 37%, 25%)`,
  border: `hsl(0, 0%, 88%)`,
  placeholder: `hsl(0, 0%, 80%)`,
  legal: `hsl(0, 0%, 55%)`,
  black: `hsl(0, 0%, 0%)`,
  white: `hsl(0, 0%, 100%)`,
  basicGreen: `hsl(156, 40%, 46%)`,
  basicGreenBg: `hsla(156, 40%, 46%,.1)`,
  goldYellow: `hsl(44, 100%, 50%)`,
  lightBlue: `hsl(203, 38%, 62%)`,
  lightBlueBg: `hsla(203, 38%, 62%, .1)`,
  dvv: {
    primary: '#FF9E16',
    secondary: '#002D7D',
    darker: '#C06A00',
  },
  myIndex: {
    primary: '#2F39D9',
    secondary: '#091a65',
    darker: '#091a65',
  },
  gray: {
    100: 'hsl(0, 0%, 94%)',
    200: 'hsl(0, 0%, 90%)',
    300: 'hsl(0, 0%, 80%)',
    400: 'hsl(0, 0%, 70%)',
    500: 'hsl(0, 0%, 60%)',
    lightest: `hsl(0, 0%, 44%)`,
    lightestBg: `hsla(0, 0%, 44%, .1)`,
    lighter: `hsl(0, 0%, 65%)`,
    75: `hsl(204, 45%, 97%)`,
  },
  red: {
    100: `hsl(354, 81%, 85%)`,
    200: `hsl(354, 81%, 62%)`,
    300: `hsl(354, 81%, 42%)`,
    400: `hsl(354, 81%, 32%)`,
    500: `hsl(354, 81%, 27%)`,
    600: `hsl(354, 81%, 22%)`,
  },
  blue: {
    100: '#9CBED3',
    200: '#80ABC6',
    300: '#4D82A8',
    400: '#406C8C',
    500: '#32546C',
    600: 'hsl(205, 37%, 25%)',
  },
};
